<template id="navbar-dropdown-wrapper">
  <base-dropdown>
    <div slot="button" v-if="user" class="flex items-center text-grey-darker hover:text-green-dark">
      <font-awesome-icon :icon="['far', 'user-circle']" class="text-2xl" />
    </div>
    <div slot="items">
      <!-- <router-link :to="{ name: 'account' }" class="inline-block w-full px-3 py-2 hover:bg-grey-lighter rounded">
        Account
      </router-link> -->
      <span class="inline-block w-full px-3 py-2 mt-1 hover:bg-grey-lighter text-red rounded cursor-pointer" @click="logout">
        Uitloggen
      </span>
    </div>
  </base-dropdown>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { mapState } from 'vuex';

export default {
  template: '#navbar-dropdown-wrapper',
  name: 'NavbarDropdown',
  components: {
    FontAwesomeIcon
  },
  methods: {
    logout: function() {
      this.$store.dispatch('auth/logout');
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  }
};
</script>
